/**
 * Redemptions and coupons
 * Includes Loyalty Redemptions and Coupon codes:
 *  - Cashback/Saldo puntos
 *  - Premium balance
 *  - Coupon codes
*/

const { delegateEvent } = require('../utilities/javascriptUtils');
const { checkValueIsEmpty } = require('../components/formControl');
const getBaseConfig = require('../common/getBaseConfig');
const javascriptUtils = require('../utilities/javascriptUtils');

const BASE_CONFIG = getBaseConfig();
const LOYALTY_MESSAGE_SELECTOR = '.promotion-information--loyalty';
const CASHBACK_ITEM_ID = 'redemptions-coupons__cashback';
const CASHBACK_ROW_SELECTOR = '.redemptions-coupons__item';
const CASHBACK_VALUE_SELECTOR = '.redemptions-coupons__value';
const CASHBACK_REMAINING_VALUE_SELECTOR = '.redemptions-coupons__value--remaining';
const CASHBACK_ROW_ELEMENT = document.getElementById(CASHBACK_ITEM_ID)?.closest(CASHBACK_ROW_SELECTOR);
const CASHBACK_APPLIED_REMAINING_ELEMENT = document.querySelector('.cashback-applied-remaining');
const CASHBACK_ADDITIONAL_INFO_ELEMENT = document.querySelector('.cashback-info-message');

/**
 * Opens Redemptions And Coupons block collapsible
 *  for desktop only
 *
 *  Note: replaced by direct activation in the template components/redemptionsAndCoupons.isml
 *  Probably future use for a ABTest
 */
/**
function openPromoCodeBlock() {
    const promoCodeTitle = document.querySelector('.redemptions-coupons .title');
    var deviceUtilities = require('../utilities/deviceUtilities');
    if (deviceUtilities.isDesktop() && promoCodeTitle) {
        $(promoCodeTitle).trigger('click');
    }
}
*/

/**
 * Updates form errors with given message or
 *  clears it if no message is given
 * @param {(string | null)} message message optional
 */
function updateFormError(message) {
    var couponErrors = document.querySelector('.redemptions-coupons-form .invalid-feedback');
    couponErrors.innerHTML = message || '';
}

/**
 * Shows corresponding cashback promotion name
 *  in applied promotion info
 * @param {string} cashbackType - cashbackType
 */
function showCashbackPromotionName(cashbackType) {
    document.querySelectorAll('.promotion-name').forEach((name)=> {
        name.classList.add('d-none');
    });
    document.querySelector('.promotion-name--' + cashbackType)?.classList.remove('d-none');
}

/**
 * Hides the Loyalty Redemption Applied Message.
 *  Element used for both Cashback and PremiumBalance
 */
function hideRedemptionAppliedMessage() {
    var appliedMessageElement = document.querySelector(LOYALTY_MESSAGE_SELECTOR);
    if (appliedMessageElement) {
        appliedMessageElement.classList.add('d-none');
    }
}

/**
 * Handles form submit event listener
 * callback decides what custom event to throw
 *  - loyalty redemptions
 *  - coupon code
 */
function setSubmitEventListener() {
    delegateEvent('click', '.redemptions-coupons__submit-btn', function (event) {
        event.preventDefault();
        var selectedOption = document.querySelector('input[name=redemptionsAndCouponsRadioBtn]:checked')?.value;

        updateFormError();

        var form = document.querySelector('.redemptions-coupons-form');
        var isAdnOrder = form.dataset.isAdnOrder === 'true' || false;
        var customEventName;

        if (selectedOption === BASE_CONFIG.promotionType.COUPON) {
            customEventName = 'redemptionsAndCoupons:couponCode';
        } else if (selectedOption === BASE_CONFIG.loyalty.promotionType.cashback
            || selectedOption === BASE_CONFIG.loyalty.promotionType.premiumBalance
        ) {
            customEventName = 'redemptionsAndCoupons:loyaltyRedemptions';
        }

        if (isAdnOrder) {
            customEventName += '--AdnOrder';
        }

        javascriptUtils.triggerCustomEvent(document, customEventName);
    });
}

/**
 * Hanldes form Status based on the coupon code input status
 * @param {Element} [submitButton] submit button
 */
function handleButtonStatusForCoupons(submitButton) {
    var button = submitButton || document.querySelector('.redemptions-coupons__submit-btn');
    var codeInput = document.querySelector('.coupon-code-field');
    button.disabled = checkValueIsEmpty(codeInput);
}

/**
 * Hanldes form Status
 */
function handleFormStatus() {
    var submitButton = document.querySelector('.redemptions-coupons__submit-btn');
    var selectedOption = document.querySelector('input[name=redemptionsAndCouponsRadioBtn]:checked');

    if (submitButton.length <= 0) {
        return;
    }

    if (!selectedOption || selectedOption.length <= 0) {
        submitButton.disabled = true;
        return;
    }

    updateFormError();

    if (selectedOption.value === BASE_CONFIG.promotionType.COUPON) {
        handleButtonStatusForCoupons(submitButton);
    } else {
        submitButton.disabled = false;
    }
}

/**
 * Sets an event for when coupon code input y clicked,
 *  corresponding radio button is checked
 */
function setCouponCodeInputEvent() {
    delegateEvent('click', '.coupon-code-field', function () {
        // Select Coupon radio button
        var couponRadioButton = document.querySelector('.redemptions-coupons__input--coupon');
        if (couponRadioButton.length !== -1) {
            couponRadioButton.checked = true;
            handleButtonStatusForCoupons();
        }
    });
}

/**
 * Set event for radio buttons change, and handle form status
 *  if the selected option is coupon codes, checks the code input
 */
function setFormStatusEvents() {
    delegateEvent('change', '.redemptions-coupons__input', function () {
        handleFormStatus();
    });

    delegateEvent('keyup', '.coupon-code-field', function () {
        handleButtonStatusForCoupons();
    });
}

/**
 * Updates cashback selector label to show remaining amount
 *  and hide available amount.
 * @param {string} remainingCashbackAmount remaining amount
 *
 */
function updateCashbackSelectorLabel(remainingCashbackAmount) {
    if (!CASHBACK_ROW_ELEMENT) return;
    var cashbackAmountElement = CASHBACK_ROW_ELEMENT.querySelector(CASHBACK_VALUE_SELECTOR);
    var remainingAmountElement = CASHBACK_ROW_ELEMENT.querySelector(CASHBACK_REMAINING_VALUE_SELECTOR);
    var remainingAmount = remainingAmountElement?.querySelector('.remaining-value');
    if (remainingAmount) {
        remainingAmount.innerHTML = remainingCashbackAmount;
    }

    remainingAmountElement?.classList.remove('d-none');
    cashbackAmountElement?.classList.add('d-none');
}

/**
 * Resets cashback selector label to show available amount
 *  and hide remaining amount.
 */
function resetCashbackSelectorLabel() {
    if (!CASHBACK_ROW_ELEMENT) return;
    var cashbackAmountElement = CASHBACK_ROW_ELEMENT?.querySelector(CASHBACK_VALUE_SELECTOR);
    var remainingAmountElement = CASHBACK_ROW_ELEMENT?.querySelector(CASHBACK_REMAINING_VALUE_SELECTOR);
    var remainingAmount = remainingAmountElement?.querySelector('.remaining-value');
    if (remainingAmount) {
        remainingAmount.innerHTML = '';
    }

    remainingAmountElement?.classList.add('d-none');
    cashbackAmountElement?.classList.remove('d-none');
}

/**
 * Resets redemption applied messages:
 *  - redemption applied message
 *  - cashback label (remaining amount)
 */
function resetRedemptionMessages() {
    hideRedemptionAppliedMessage();
    resetCashbackSelectorLabel();
}

/**
 * Shows the Loyalty Redemption Applied Message,
 *  after updating specific messages for cashback or premiumBalance
 * @param {string} cashbackType cashback type
 * @param {number} totalCashbackApplied applied cashback amount
 */
function showRedemptionAppliedMessage(cashbackType, totalCashbackApplied) {
    showCashbackPromotionName(cashbackType);

    var appliedMessageElement = document.querySelector(LOYALTY_MESSAGE_SELECTOR);
    appliedMessageElement?.classList.remove('d-none');

    if (cashbackType === BASE_CONFIG.loyalty.promotionType.cashback) {
        CASHBACK_ADDITIONAL_INFO_ELEMENT?.classList.remove('d-none');

        if (CASHBACK_APPLIED_REMAINING_ELEMENT) {
            CASHBACK_APPLIED_REMAINING_ELEMENT.innerHTML = totalCashbackApplied;
            CASHBACK_APPLIED_REMAINING_ELEMENT.classList.remove('d-none');
        }
    } else {
        CASHBACK_ADDITIONAL_INFO_ELEMENT?.classList.add('d-none');
        CASHBACK_APPLIED_REMAINING_ELEMENT?.classList.add('d-none');
    }
}

/**
 * Updates Data for Coupon remove modal
 */
function setUpdateCouponRemoveModalDataEvent() {
    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        const couponCode = $(this).data('code');
        const uuid = $(this).data('uuid');
        const $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        const $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });
}

module.exports = {
    methods: {
        hideRedemptionAppliedMessage: hideRedemptionAppliedMessage,
        resetCashbackSelectorLabel: resetCashbackSelectorLabel,
        resetRedemptionMessages: resetRedemptionMessages,
        showRedemptionAppliedMessage: showRedemptionAppliedMessage,
        updateCashbackSelectorLabel: updateCashbackSelectorLabel,
        updateFormError: updateFormError
    },
    init: function () {
        setSubmitEventListener();
        setCouponCodeInputEvent();
        setFormStatusEvents();
        setUpdateCouponRemoveModalDataEvent();
    }
};
